import { Data } from '@blade/std-lib'

import type { PlatformUpdate } from '@root/shared'

export class LatestUpdate extends Data.TaggedClass('LatestUpdate') {}
export class UpdateCheck extends Data.TaggedClass('UpdateCheck') {}

export class UpdateCheckError extends Data.TaggedError('UpdateCheckError')<{
  cause: unknown
}> {}
export class UpdateAvailable extends Data.TaggedClass('UpdateAvailable')<{
  update: PlatformUpdate
}> {}

export class UpdateDownloadError extends Data.TaggedError(
  'UpdateDownloadError',
)<{
  update: PlatformUpdate
  cause: unknown
}> {}

export class UpdateReady extends Data.TaggedClass('UpdateReady')<{
  update: PlatformUpdate
}> {}
export class UpdateInstallation extends Data.TaggedClass('UpdateInstallation')<{
  update: PlatformUpdate
}> {}

export class UpdateInstallError extends Data.TaggedError('UpdateInstallError')<{
  cause: unknown
  update: PlatformUpdate
}> {}

export class UpdateRelaunchError extends Data.TaggedError(
  'UpdateRelaunchError',
)<{
  cause: unknown
}> {}

export type UpdateState =
  | LatestUpdate
  | UpdateCheck
  | UpdateCheckError
  | UpdateAvailable
  | UpdateDownloadError
  | UpdateReady
  | UpdateInstallation
  | UpdateInstallError
  | UpdateRelaunchError

export const match = Data.match
